import { SOURCE, TARGET, ConnectionEditing } from './../constants';
export class ConnectionEditUndoUnit {
    constructor(item, undoSource, undoTarget) {
        this.item = item;
        this._undoSource = undoSource;
        this._undoTarget = undoTarget;
        this._redoSource = item.source();
        this._redoTarget = item.target();
        this.title = ConnectionEditing;
    }
    undo() {
        this.item._updateConnector(this._undoSource, SOURCE);
        this.item._updateConnector(this._undoTarget, TARGET);
        this.item.updateModel();
    }
    redo() {
        this.item._updateConnector(this._redoSource, SOURCE);
        this.item._updateConnector(this._redoTarget, TARGET);
        this.item.updateModel();
    }
}
